export enum QuestionTypeV1 {
  likert = 'Questions::Likert',
  openEnded = 'Questions::OpenEnded',
}
